import _createForOfIteratorHelper from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/mohammedshalabi/Projects/hakawati/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

var _Engine_initialized, _Engine_loader;

import { Loader } from "./Core/Loader";
import { Plugins } from "./Core/Utils/Plugins";
export var Engine = /*#__PURE__*/function () {
  function Engine() {
    _classCallCheck(this, Engine);

    _Engine_initialized.set(this, void 0);

    _Engine_loader.set(this, void 0);

    __classPrivateFieldSet(this, _Engine_initialized, false, "f");

    this.domArray = [];

    __classPrivateFieldSet(this, _Engine_loader, new Loader(this), "f");

    this.plugins = new Plugins(this);
  }

  _createClass(Engine, [{
    key: "init",
    value: function init() {
      if (!__classPrivateFieldGet(this, _Engine_initialized, "f")) {
        __classPrivateFieldSet(this, _Engine_initialized, true, "f");
      }
    }
  }, {
    key: "loadFromArray",
    value: function () {
      var _loadFromArray = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tagId, options, index) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", __classPrivateFieldGet(this, _Engine_loader, "f").load(tagId, options, index));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadFromArray(_x, _x2, _x3) {
        return _loadFromArray.apply(this, arguments);
      }

      return loadFromArray;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(tagId, options) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", __classPrivateFieldGet(this, _Engine_loader, "f").load(tagId, options));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function load(_x4, _x5) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "set",
    value: function () {
      var _set = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id, element, options) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", __classPrivateFieldGet(this, _Engine_loader, "f").set(id, element, options));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function set(_x6, _x7, _x8) {
        return _set.apply(this, arguments);
      }

      return set;
    }()
  }, {
    key: "loadJSON",
    value: function () {
      var _loadJSON = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(tagId, pathConfigJson, index) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", __classPrivateFieldGet(this, _Engine_loader, "f").loadJSON(tagId, pathConfigJson, index));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function loadJSON(_x9, _x10, _x11) {
        return _loadJSON.apply(this, arguments);
      }

      return loadJSON;
    }()
  }, {
    key: "setJSON",
    value: function () {
      var _setJSON = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id, element, pathConfigJson, index) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", __classPrivateFieldGet(this, _Engine_loader, "f").setJSON(id, element, pathConfigJson, index));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setJSON(_x12, _x13, _x14, _x15) {
        return _setJSON.apply(this, arguments);
      }

      return setJSON;
    }()
  }, {
    key: "setOnClickHandler",
    value: function setOnClickHandler(callback) {
      __classPrivateFieldGet(this, _Engine_loader, "f").setOnClickHandler(callback);
    }
  }, {
    key: "dom",
    value: function dom() {
      return __classPrivateFieldGet(this, _Engine_loader, "f").dom();
    }
  }, {
    key: "domItem",
    value: function domItem(index) {
      return __classPrivateFieldGet(this, _Engine_loader, "f").domItem(index);
    }
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _iterator, _step, instance;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _iterator = _createForOfIteratorHelper(this.dom());
                _context6.prev = 1;

                _iterator.s();

              case 3:
                if ((_step = _iterator.n()).done) {
                  _context6.next = 9;
                  break;
                }

                instance = _step.value;
                _context6.next = 7;
                return instance.refresh();

              case 7:
                _context6.next = 3;
                break;

              case 9:
                _context6.next = 14;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](1);

                _iterator.e(_context6.t0);

              case 14:
                _context6.prev = 14;

                _iterator.f();

                return _context6.finish(14);

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[1, 11, 14, 17]]);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "addShape",
    value: function () {
      var _addShape = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(shape, drawer, init, afterEffect, destroy) {
        var customDrawer;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (typeof drawer === "function") {
                  customDrawer = {
                    afterEffect: afterEffect,
                    destroy: destroy,
                    draw: drawer,
                    init: init
                  };
                } else {
                  customDrawer = drawer;
                }

                this.plugins.addShapeDrawer(shape, customDrawer);
                _context7.next = 4;
                return this.refresh();

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function addShape(_x16, _x17, _x18, _x19, _x20) {
        return _addShape.apply(this, arguments);
      }

      return addShape;
    }()
  }, {
    key: "addPreset",
    value: function () {
      var _addPreset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(preset, options) {
        var override,
            _args8 = arguments;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                override = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : false;
                this.plugins.addPreset(preset, options, override);
                _context8.next = 4;
                return this.refresh();

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function addPreset(_x21, _x22) {
        return _addPreset.apply(this, arguments);
      }

      return addPreset;
    }()
  }, {
    key: "addPlugin",
    value: function () {
      var _addPlugin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(plugin) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.plugins.addPlugin(plugin);
                _context9.next = 3;
                return this.refresh();

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function addPlugin(_x23) {
        return _addPlugin.apply(this, arguments);
      }

      return addPlugin;
    }()
  }, {
    key: "addPathGenerator",
    value: function () {
      var _addPathGenerator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(name, generator) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.plugins.addPathGenerator(name, generator);
                _context10.next = 3;
                return this.refresh();

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function addPathGenerator(_x24, _x25) {
        return _addPathGenerator.apply(this, arguments);
      }

      return addPathGenerator;
    }()
  }, {
    key: "addInteractor",
    value: function () {
      var _addInteractor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(name, interactorInitializer) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this.plugins.addInteractor(name, interactorInitializer);
                _context11.next = 3;
                return this.refresh();

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function addInteractor(_x26, _x27) {
        return _addInteractor.apply(this, arguments);
      }

      return addInteractor;
    }()
  }, {
    key: "addMover",
    value: function () {
      var _addMover = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(name, moverInitializer) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this.plugins.addParticleMover(name, moverInitializer);
                _context12.next = 3;
                return this.refresh();

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function addMover(_x28, _x29) {
        return _addMover.apply(this, arguments);
      }

      return addMover;
    }()
  }, {
    key: "addParticleUpdater",
    value: function () {
      var _addParticleUpdater = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(name, updaterInitializer) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                this.plugins.addParticleUpdater(name, updaterInitializer);
                _context13.next = 3;
                return this.refresh();

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function addParticleUpdater(_x30, _x31) {
        return _addParticleUpdater.apply(this, arguments);
      }

      return addParticleUpdater;
    }()
  }]);

  return Engine;
}();
_Engine_initialized = new WeakMap(), _Engine_loader = new WeakMap();